import { useEffect, useState } from "react";
import { Card, Form, Offcanvas } from "react-bootstrap";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";

interface AddEventsGalleryProps {
  show: boolean;
  handleClose: () => void;
  data?: any;
  event?: any;
  mode?: "add" | "edit";
}

const AddEventsGallery = ({
  show,
  handleClose,
  data,
  event,
  mode,
}: AddEventsGalleryProps) => {
  const [events, setEvents] = useState<any[]>([
    {
      title: "",
      description: "",
      images: [{ image: "" }],
      videoUrl: "",
      link: "",
      publishDate: "",
      location: "",
    },
  ]);

  const [isLoading, setLoading] = useState(false);
  const [fileError, setFileError] = useState<string>("");
   const [errors, setErrors] = useState<any[]>([]);

  /* ---------------- RESET FORM ---------------- */
  useEffect(() => {
  let initialEvents;

  if (mode === "edit" && event) {
    initialEvents = [
      {
        title: event.title || "",
        description: event.description || "",
        images:
          event.images && event.images.length > 0
            ? event.images.map((img: any) =>
                typeof img === "string"
                  ? { image: img }
                  : { image: img.image || img.url }
              )
            : [{ image: "" }],
        videoUrl: event.videoUrl || "",
        link: event.link || "",
        publishDate: event.publishDate || "",
        location: event.location || "",
      },
    ];
  } else {
    initialEvents = [
      {
        title: "",
        description: "",
        images: [{ image: "" }],
        videoUrl: "",
        link: "",
        publishDate: "",
        location: "",
      },
    ];
  }

  setEvents(initialEvents);

  // ✅ IMPORTANT: reset errors with SAME STRUCTURE
  setErrors(initialEvents.map(() => ({})));

}, [show, mode, event]);
  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];
  /* ---------------- IMAGE UPLOAD ---------------- */
  const uploadFile = (file: File, eventIndex: number, imageIndex: number) => {
    const formData = new FormData();
    formData.append("file", file);
      formData.append("storage", "WOMEN_IN_ENERGY");
    WebService.fileUploadAPI({
      action: `upload`,
      body: formData,
    }).then((res: any) => {
      const updated = [...events];
      updated[eventIndex].images[imageIndex].image = res.data?.url;
      setEvents(updated);
    });
  };

      const validateEvents = () => {
  const newErrors: any[] = [];

  events.forEach((event, index) => {
    const eventErrors: any = {};

    // ✅ Title required
    if (!event.title || !event.title.trim()) {
      eventErrors.title = "Title is required";
    }

    // ✅ At least 1 image required
    const validImages = event.images?.filter((img: any) =>  img.image || img.url || typeof img === "string");

    if (!validImages || validImages.length === 0) {
      eventErrors.images = "At least one image is required";
    }

    newErrors[index] = eventErrors;
  });

  setErrors(newErrors);

  // check if any error exists
  const hasError = newErrors.some(
    (err) => Object.keys(err).length > 0
  );

  return !hasError;
};

  /* ---------------- SAVE ---------------- */
  const handleSave = () => {
    if (!validateEvents()) return;
    if (!data?._id) {
      toast.error("Please save INFO first");
      return;
    }

    setLoading(true);

    let allEvents = data?.events || [];

    if (mode === "add") {
      events.forEach((e) => allEvents.push(e));
    }

    if (mode === "edit" && event?.index !== undefined) {
      allEvents[event.index] = events[0];
    }

    const body = new FormData();
    body.append("events", JSON.stringify(allEvents));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: `women-in-energy/addEvents`,
      body,
    })
      .then(() => {
        toast.success("Event highlight saved");
        handleClose();
      })
      .catch(() => toast.error("Failed to save event"))
      .finally(() => setLoading(false));
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="offcanvas-custom"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          {mode === "add" ? "Add Event Gallery" : "Edit Event Gallery"}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Card className="p-3 bg-light my-3 position-relative">
            <span
              className="bg-white position-absolute rounded small"
              style={{ top: "-12px", left: "12px", padding: "0 8px" }}
            >
              Event Gallery
            </span>
            <Form.Group className="mb-2">
              {events.map((item, index) => (
                <div key={index} className="mb-4 border rounded p-3 bg-light">
                  <div className="d-flex align-items-start">
                    <span
                      style={{
                        cursor: "grab",
                        marginRight: 8,
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20,
                        color: "#888",
                        marginTop: 10,
                      }}
                      title="Drag to reorder"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <circle cx="5" cy="6" r="1.5" />
                        <circle cx="5" cy="10" r="1.5" />
                        <circle cx="5" cy="14" r="1.5" />
                        <circle cx="11" cy="6" r="1.5" />
                        <circle cx="11" cy="10" r="1.5" />
                        <circle cx="11" cy="14" r="1.5" />
                      </svg>
                    </span>
                    <div style={{ flex: 1 }} className="highlight-item">

                      {/* TITLE */}
                      <Form.Control
                        type="text"
                        placeholder="Title"
                        className="mt-2"
                        value={item.title}
                        onChange={(e) => {
                          const updated = [...events];
                          updated[index].title = e.target.value;
                          setEvents(updated);

                           const newErrors = [...errors];
  if (newErrors[index]?.title) {
    delete newErrors[index].title;
    setErrors(newErrors);
  }
                        }}
                      />
                      {errors[index]?.title && (
  <div className="text-danger" style={{ fontSize: "12px" }}>
    {errors[index].title}
  </div>
)}

                      {/* DESCRIPTION */}
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Description"
                        className="mt-2"
                        value={item.description}
                        onChange={(e) => {
                          const updated = [...events];
                          updated[index].description = e.target.value;
                          setEvents(updated);
                        }}
                      />

                      {/* VIDEO URL */}
                      <Form.Control
                        type="text"
                        placeholder="Video URL"
                        className="mt-2"
                        value={item.videoUrl}
                        onChange={(e) => {
                          const updated = [...events];
                          updated[index].videoUrl = e.target.value;
                          setEvents(updated);
                        }}
                      />

                      {/* LINK */}
                      {/* <Form.Control
                        type="text"
                        placeholder="External Link"
                        className="mt-2"
                        value={item.link}
                        onChange={(e) => {
                          const updated = [...events];
                          updated[index].link = e.target.value;
                          setEvents(updated);
                        }}
                      /> */}

                      {/* PUBLISH DATE */}
                      <Form.Control
                        type="date"
                        className="mt-2"
                         max={new Date().toISOString().split("T")[0]}
                        value={item.publishDate}
                        onChange={(e) => {
                          const updated = [...events];
                          updated[index].publishDate = e.target.value;
                          setEvents(updated);
                        }}
                      />

                      <Form.Control
                        type="text"
                        placeholder="Location"
                        className="mt-2"
                        value={item.location}
                        onChange={(e) => {
                          const updated = [...events];
                          updated[index].location = e.target.value;
                          setEvents(updated);
                        }}
                      />

                      <Form.Label className="label">Image<span className="text-danger">*</span></Form.Label>
                      <p
                            className="text-primary mt-1"
                            style={{ fontSize: "13px" }}
                          >
                            Note: Please upload an image of size:{" "}
                            <strong>380 × 232 px</strong> in{" "}
                            <strong>.png, .jpeg, .jpg or .svg</strong> format.
                          </p>
                      {item.images.map((img: any, imgIndex: number) => (
                        <div key={imgIndex} className="mt-2">
                          
                          <div className="d-flex align-items-center">
                            <Form.Control
                              type="file"
                              accept="image/*"
                             onChange={(e) => {
                                const input = e.target as HTMLInputElement;
                                const file = input.files?.[0];

                                if (!file) return;

                                if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                  const msg =
                                    "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                  setFileError(msg);
                                  toast.error(msg);
                                  input.value = "";
                                  return;
                                }
                                setFileError("");
                                uploadFile(file, index, imgIndex);
                              }}
                            />

                            <PlusSquareFill
                              className="ms-2 cursor-pointer"
                              onClick={() => {
                                const updated = [...events];
                                updated[index].images.push({ image: "" });
                                setEvents(updated);
                              }}
                            />

                            {item.images.length > 1 && (
                              <DashSquareFill
                                className="ms-2 cursor-pointer"
                                onClick={() => {
                                  const updated = [...events];
                                  updated[index].images = updated[
                                    index
                                  ].images.filter(
                                    (_: any, i: number) => i !== imgIndex
                                  );
                                  setEvents(updated);
                                }}
                              />
                            )}
                          </div>

                          {img.image && (
                            <img
                              src={img.image}
                              style={{
                                maxWidth: "100%",
                                maxHeight: 120,
                                objectFit: "contain",
                                marginTop: 10,
                                borderRadius: 6,
                              }}
                            />
                          )}
                        </div>
                      ))}
                      {errors[index]?.images && (
  <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
    {errors[index].images}
  </div>
)}

                      {/* ADD / REMOVE */}
                      <div className="d-flex mt-2">
                        {/* {mode !== "edit" && (
                          <PlusSquareFill
                            className="cursor-pointer"
                            onClick={() =>
                              setEvents([
                                ...events,
                                {
                                  title: "",
                                  description: "",
                                  images: [{ image: "" }],
                                  videoUrl: "",
                                  link: "",
                                  publishDate: "",
                                },
                              ])
                            }
                          />
                        )} */}
                        {events.length > 1 && (
                          <DashSquareFill
                            className="cursor-pointer ms-2"
                            onClick={() =>
                              setEvents(events.filter((_, i) => i !== index))
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Form.Group>
          </Card>
        </Form>
      </Offcanvas.Body>

      <div className="p-3">
        <CustomButton
          label="Save"
          className="w-100"
          isLoading={isLoading}
          onClick={handleSave}
        />
      </div>
    </Offcanvas>
  );
};

export default AddEventsGallery;
